<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <base-page-component :has-nav="false">
    <div style="background-color: #F4F8FF;height: calc(100% - 0px)">
      <div class="bg-white m-auto">
        <div class="flex a-center h-60">
          <Button @click="createNewPage()" class="m-l-25" type="primary">新增人员</Button>
          <Input class="m-l-15" placeholder="姓名" style="width: 240px" v-model="title"/>
          <Button @click="onSearchClick" class="m-l-15">搜索</Button>
        </div>

        <div class="m-h-25 ">
          <Table :columns="columns" :data="dataList" :height="tableHeight">
            <template v-slot:operation="{row,index}">
              <div class="flex j-start fs-12">
                <span @click="onUserEditClick(row)" class="m-r-20"
                      style="color:#3B80FF;cursor: pointer">个人档案</span>
                <!--<span @click="onQrShowClick(row)" class="m-r-20" style="color:#3B80FF;cursor: pointer">二维码</span>-->
                <span @click="delPage(row,index)" style="color:red ;cursor: pointer">删除</span>
              </div>
            </template>
          </Table>
          <Page :current="tablePage.currentPage" :page-size="tablePage.pageSize" :page-size-opts="pageSizeOpts"
                :total="tablePage.total" @on-change="onPageChange" @on-page-size-change="onPageSizeChange"
                class="m-t-10 p-b-10" show-sizer show-total/>
        </div>
      </div>
    </div>

    <Modal :closable="false"
           :mask-closable="false"
           @on-visible-change="onModalClose"
           class-name="vertical-center-modal"
           footer-hide
           v-model="showUserAdd"
           width="750">
      <add-admin :open="showUserAdd" @cancelclick="showUserAdd=false" @subclick="onAdminUserAdd"/>
    </Modal>
    <Modal :closable="false"
           :mask-closable="false"
           @on-visible-change="onModalClose"
           class-name="vertical-center-modal"
           footer-hide
           v-model="showUserEdit"
           width="750">
      <edit-admin :open="showUserEdit" :uid="editUser" @cancelclick="showUserEdit=false" @subclick="onAdminUserEdit"/>
    </Modal>
    <Modal :closable="false"
           :mask-closable="false"
           @on-visible-change="onModalClose"
           class-name="vertical-center-modal"
           footer-hide
           v-model="showCustomerServiceEdit"
           width="750">
      <edit-customer-service :open="showCustomerServiceEdit" :uid="editCustomerServiceUser" @cancelclick="showCustomerServiceEdit=false" @subclick="onCustomerServiceEdit"/>
    </Modal>
  </base-page-component>

</template>

<script>
import BasePageComponent from '@/components/common/BasePageComponent'
import {mapActions} from 'vuex'
import AddAdmin from './component/AddAdmin'
import mixin from '../../config/mixinfile'
import EditAdmin from '@/views/basesettings/component/EditAdmin'
import EditCustomerService from '@/views/basesettings/component/EditCustomerService'

export default {
  name: 'LoginAccounts',
  mixins: [mixin.mixin],
  components: {
    EditCustomerService,
    EditAdmin,
    AddAdmin,
    BasePageComponent,
  },
  data () {
    return {
      showUserAdd: false,       //新建人员弹框
      showUserEdit: false,       //编辑人员弹框
      showCustomerServiceEdit: false,       //编辑客服弹框

      editUser: 0,              //编辑Id
      editCustomerServiceUser: 0,              //编辑客服Id

      tableHeight: 620,         //表格高度
      title: '',                //搜素内容
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 30,
      },
      columns: [{
        title: '用户编号',
        align: 'left',
        key: 'roleSerial',
        width: 140,
      }, {
        title: '姓名',
        key: 'name',
        width: 140,
        tooltip: true
      }, {
        title: '登陆账号',
        key: 'phone',
        width: 200,
        align: 'center',
        tooltip: true
      }, {
        title: '权限',
        key: 'role',
        width: 160,
      }, {title: '  ',}, {
        title: '操作',
        slot: 'operation',
        width: 240
      }
      ],
      dataList: []
    }
  },
  mounted () {
    this.init()
    this.getRoleLists()
  },
  activated () {
    this.setTableHeight()
    this.getRoleLists()
  },
  methods: {
    init () {
      this.setTableHeight()
    },
    setTableHeight(){
      this.tableHeight = window.innerHeight - 250
      window.onresize = () => {
        this.tableHeight = window.innerHeight - 250
      }
    },
    getRoleLists () {
      let params = {
        pageNum: this.tablePage.currentPage,
        pageSize: this.tablePage.pageSize,
      }
      if (this.title) {
        params.name = this.title
      }
      this.getRoleList(params).then(res => {
        if (res.code === 0) {
          this.dataList = res.data.list.map(child => {
              child.role = this.getRole(child.roleType)
              return child
            }
          )
          this.tablePage.total = res.data.total || 0
        }
      })
    },
    getRole (type) {
      let roleName = ''
      switch (type) {
        case 1:
          roleName = '超级管理员'
          break
        case 2:
          roleName = '管理员'
          break
        case 3:
          roleName = '普通用户'
          break
        case 4:
          roleName = '客服'
          break
      }
      return roleName
    },
    onQrShowClick (row) {

    },
    onUserEditClick (row) {
      if (row.roleType=== 4){
        this.editCustomerServiceUser = row.roleId
        this.showCustomerServiceEdit = true
      }else{
        this.editUser = row.roleId
        this.showUserEdit = true
      }
    },
    //删除页面
    delPage (row) {
      const content = '<p>确定要删除页面 ' + row.name + ' 吗?</p>'
      this.$Modal.confirm({
        title: '提示',
        content: content,
        onOk: () => {
          if (row.roleType === 4) {
            let params = {
              idList: row.roleId
            }
            this.delCustomerServiceUser(params).then(res => {
              if (res.code === 0) {
                this.getRoleLists()
              } else {
                this.$Message.info(res.msg)
              }
            })
          }else{
            let params = {
              entId: this.entId,
              roleIdList: row.roleId
            }
            this.delEmployee(params).then(res => {
              if (res.code === 0) {
                this.getRoleLists()
              } else {
                this.$Message.info(res.msg)
              }
            })
          }
        },
        onCancel: () => {
        }
      })
    },
    onSearchClick () {
      this.tablePage.currentPage = 1
      this.getRoleLists()
    },
    onPageChange (e) {
      this.tablePage.currentPage = e
      this.getRoleLists()
    },
    onPageSizeChange (e) {
      this.tablePage.pageSize = e
      if (this.tablePage.currentPage === 1) {
        this.getRoleLists()
      }
    },
    /**
     * 新增成员
     */
    createNewPage () {
      this.showUserAdd = true
    },
    /**
     * 添加完成刷新关闭
     */
    onAdminUserAdd () {
      this.getRoleLists()
      this.showUserAdd = false
    },
    /**
     * 添加完成刷新关闭
     */
    onAdminUserEdit () {
      this.getRoleLists()
      this.showUserEdit = false
    },
    /**
     * 添加完成刷新关闭
     */
    onCustomerServiceEdit () {
      this.getRoleLists()
      this.showCustomerServiceEdit = false
    },
    /**
     * 弹框关闭清空数据
     * @param status
     */
    onModalClose (status) {
      if (!status) {
        this.editUser = 0
        this.editCustomerServiceUser = 0
      }
    },
    ...mapActions([
      'getRoleList',
      'delEmployee',
      'delCustomerServiceUser',
    ])
  }
}
</script>

<style lang="scss" scoped>
</style>
